import React from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';

@connect(
    state => ({
        contacts: state.activeClient.contacts
    })
)
export default class ClientContactsDropdown extends React.Component {
    static propTypes = {
        contacts: React.PropTypes.array.isRequired,
        value: React.PropTypes.string.isRequired,
        onChange: React.PropTypes.func.isRequired
    };
    render() {
        var contactOptions = this.props.contacts.map(c =>
                ({value: c.id, label: `${c.firstName} ${c.lastName}`})
        );

        return (
            <Select
                placeholder={'Select contact'}
                multi={false}
                name="form-field-name"
                value={this.props.value}
                options={contactOptions}
                onChange={this.props.onChange} />
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientContactsDropdown.js